import script from "./Dashboard-link.vue?vue&type=script&setup=true&lang=js"
export * from "./Dashboard-link.vue?vue&type=script&setup=true&lang=js"

import "./Dashboard-link.vue?vue&type=style&index=0&id=c315aeb6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c315aeb6"]])

export default __exports__